export default {
  methods: {
    formatAddressText(address) {
      let formattedText = '';
      if (!address) {
        return '';
      }

      formattedText += address.address1;

      if (!_.isEmpty(address.address2)) {
        formattedText += `, ${address.address2}`;
      }

      formattedText += `, ${address.city}`;
      formattedText += `, ${address.region}`;
      formattedText += `, ${address.postal}`;
      formattedText += `, ${address.country}`;


      return formattedText;
    },
  }
};
